import gql from "graphql-tag";

export const getUsers = gql`
  query getUsers {
    getUsers {
      id
      lastName
      firstName
      email
    }
  }
`;

export const getUtilisateur = gql`
  query getUtilisateur($utilisateurId: Int!) {
    getUtilisateur(utilisateurId: $utilisateurId) {
      id
      lastName
      firstName
      email
      phone
      entreprises {
        id
        pays
        ville
        adresse
        adresseComplement
        codePostal
        denomination
        siret
      }
    }
  }
`;

export const getNewPasswordRequest = gql`
  query getNewPasswordRequest($requestCode: String!) {
    getNewPasswordRequest(requestCode: $requestCode) {
      type
      message
      details
    }
  }
`;
